import 'Onboarding/angularModule';
import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const OnboardingHybridQuestionaryDirective = angularDirectiveToReact('onboardingHybridQuestionary', {});

export function OnboardingHybridQuestionaryComponent() {
    const [key] = useAngularToReactRoute();
    return <OnboardingHybridQuestionaryDirective key={key} />;
}
